import React from 'react'
import './index.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faX } from '@fortawesome/free-solid-svg-icons';

const ContainerCard = ({
    index,
    imageURL,
    checked,
    onChange,
    onRemove,
}) => {
    return (
        <div className="image-card">
            <input
                onChange={onChange}
                type="checkbox"
                checked={checked}
                id={`cb${index}`}
            />
            <label htmlFor={`cb${index}`}>
                <img src={imageURL} />
            </label>
            <div className="options" onClick={onRemove}>
                <FontAwesomeIcon icon={faX} className='icon-remove btn-danger' />
            </div>
        </div>
    )
}

export default ContainerCard